<template>
  <div id="change-password-template">
    <div class="login-wrapper">
      <h2 class="login-box-title">비밀번호 변경</h2>
      <div class="login-box-title-underbar"></div>
      <div class="input-group">
        <label class="session-label">대상 아이디 : {{loginId.check}}</label>
      </div>
      <div class="input-group">
        <label class="session-label">비밀번호</label>
        <input type="password" class="session-input" id='password' v-model="password" placeholder="비밀번호" title="비밀번호">
        <p class="helper-text-xs">비밀번호는 숫자, 영문, 특수문자 포함 9자 이상이어야 합니다.</p>
      </div>
      <div class="input-group">
        <label class="session-label">비밀번호 재입력</label>
        <input type="password" class="session-input" v-model="passwordConfirm" placeholder="비밀번호 재입력" title="비밀번호 재입력">
      </div>
      <button class="lg-btn block-btn btn--blue-line border-2" @click="changePassword">비밀번호 변경</button>
      <div class="session-link-group">
        <a href="/login.do" class="session-link">로그인</a>
        <span class="session-slash">/</span>
        <a href="/join.do" class="session-link">회원가입</a>
      </div>
      <div class="session-link-group">
        <p class="session-label" style="text-align:center">비밀번호찾기 문의 : 운영지원팀(TEL 1661-5516)</p>
      </div>
    </div>
  </div>
</template>
<script>
  import Axios from 'axios';

  export default {
    name: 'change-password',
    props: ['loginId'],
    data() {
      return {
        password: '',
        passwordConfirm: '',
      };
    },
    methods: {
      changePassword() {
        const pwdReg = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^*()\-_=+\\|[\]{};:'",.<>/?~`&]).{9,50}$/i;
        if (!this.password) {
          alert('비밀번호를 입력해 주세요.');
        } else if (!this.passwordConfirm) {
          alert('비밀번호를 재입력해 주세요.');
        } else if (this.password !== this.passwordConfirm) {
          alert('비밀번호가 서로 일치하지 않습니다.');
        } else if (!pwdReg.test(this.password)) {
          alert('비밀번호는 숫자, 영문, 특수문자 포함 9자 이상이어야 합니다.');
          $('#password').focus();
        } else {
          const Params = {
            password: this.password,
          };
          Axios.post('/api/members/reset-password', Params).then(() => {
            alert('비밀번호가 변경되었습니다. 로그인 페이지로 돌아갑니다.');
            location.href = '/login.do';
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
    },
  };

</script>


// WEBPACK FOOTER //
// ChangePassword.vue?163b1424